import React, { useState, useEffect } from 'react';
import HeaderOne from "../components/HeaderTwo";
import BottomFooter from "../components/BottomFooter";

const AboutUs = () => {
    const [aboutData, setAboutData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchAboutData();
    }, []);

    const fetchAboutData = async () => {
        try {
            console.log('Fetching about us from API...');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/about-us/`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });
            
            console.log('Response status:', response.status);
            
            if (!response.ok) {
                throw new Error(`Failed to fetch about us: ${response.status}`);
            }
            
            const data = await response.json();
            console.log('Fetched about us:', data);
            
            setAboutData(data);
            setLoading(false);
        } catch (err) {
            console.error('Error fetching about data:', err);
            setError('Failed to load about information');
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <>
                <HeaderOne />
                <div className="about-container">
                    <section className="hero-section">
                        <div className="hero-content">
                            <h1 className="hero-title">Loading...</h1>
                        </div>
                    </section>
                </div>
                <BottomFooter />
            </>
        );
    }

    if (error) {
        return (
            <>
                <HeaderOne />
                <div className="about-container">
                    <section className="hero-section">
                        <div className="hero-content">
                            <h1 className="hero-title">Error</h1>
                            <p className="hero-subtitle" style={{ color: 'red' }}>{error}</p>
                        </div>
                    </section>
                </div>
                <BottomFooter />
            </>
        );
    }

    if (!aboutData) {
        return (
            <>
                <HeaderOne />
                <div className="about-container">
                    <section className="hero-section">
                        <div className="hero-content">
                            <h1 className="hero-title">Not Found</h1>
                            <p className="hero-subtitle">About page not available</p>
                        </div>
                    </section>
                </div>
                <BottomFooter />
            </>
        );
    }

    return (
        <>
            <HeaderOne />

            <div className="about-container">
                {/* Hero Section */}
                <section className="hero-section">
                    <div className="hero-content">
                        <h1 className="hero-title">{aboutData.hero_title}</h1>
                        {aboutData.hero_subtitle && (
                            <p className="hero-subtitle">{aboutData.hero_subtitle}</p>
                        )}
                    </div>
                </section>

                {/* Main Content */}
                <section className="main-content">
                    <div className="content-wrapper">
                        {/* Story Section */}
                        <div className="story-section">
                            <h2>{aboutData.story_title}</h2>
                            {aboutData.story_text_1 && <p>{aboutData.story_text_1}</p>}
                            {aboutData.story_text_2 && <p>{aboutData.story_text_2}</p>}
                        </div>

                        {/* Services Section */}
                        {aboutData.service_categories && aboutData.service_categories.length > 0 && (
                            <div className="services-section">
                                <h2>{aboutData.services_title}</h2>
                                {aboutData.services_intro && (
                                    <p className="services-intro">{aboutData.services_intro}</p>
                                )}

                                <div className="services-grid">
                                    {aboutData.service_categories.map((service, index) => (
                                        <div key={service.id || index} className="service-card">
                                            <div className="service-icon">{service.icon}</div>
                                            <h3>{service.title}</h3>
                                            <ul>
                                                {service.items.map((item, idx) => (
                                                    <li key={item.id || idx}>{item.name}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Store Hours Section */}
                        {aboutData.hours && aboutData.hours.length > 0 && (
                            <div className="store-hours-section">
                                <h2>{aboutData.store_hours_title}</h2>
                                {aboutData.store_hours_intro && (
                                    <p className="store-hours-intro">{aboutData.store_hours_intro}</p>
                                )}
                                
                                <div className="hours-details">
                                    {aboutData.address_line && (
                                        <div className="address-info">
                                            <p className="address-line">{aboutData.address_line}</p>
                                        </div>
                                    )}
                                    
                                    <div className="hours-list">
                                        {aboutData.hours.map((hour, index) => (
                                            <div 
                                                key={hour.id || index} 
                                                className={`hours-item ${hour.is_closed ? 'closed' : ''}`}
                                            >
                                                <span className="day">{hour.day}:</span>
                                                <span className="time">
                                                    {hour.is_closed ? 'Closed' : hour.time}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </section>
            </div>

            <BottomFooter />
        </>
    );
};

export default AboutUs;
